import { Check, Languages } from "lucide-react";
import { Link } from "react-router-dom";
import { PageHero } from "../components/site/PageHero";
import { EmployerForm } from "../components/forms/EmployerForm";
import { ApplicantForm } from "../components/forms/ApplicantForm";
import { useSeo } from "../lib/useSeo";

const Aside = ({ title, items }) => (
  <aside className="rounded-[2rem] bg-[color:var(--mist)] p-8 lg:sticky lg:top-28">
    <h2 className="text-lg font-bold text-[color:var(--navy)]">{title}</h2>
    <ul className="mt-5 space-y-4 text-sm text-slate-700">
      {items.map((i) => (
        <li key={i} className="flex gap-3"><Check size={16} className="mt-0.5 shrink-0 text-[color:var(--teal-ink)]" />{i}</li>
      ))}
    </ul>
  </aside>
);

export function InquiryPage() {
  useSeo("Personal anfragen", "Fragen Sie unverbindlich Personal aus dem Ausland an. PACTORA klärt Ihren Bedarf und stellt geeignete Kandidaten vor.", "/personal-anfragen");
  return (
    <>
      <PageHero testid="inquiry-hero" eyebrow="Arbeitgeberanfrage" lines={["Personal anfragen."]}
        intro="Erzählen Sie uns, wen Sie suchen. Nur wenige Angaben sind verpflichtend – alles Weitere klären wir gerne im persönlichen Gespräch." />
      <section className="bg-white pb-24 md:pb-32">
        <div className="container-x grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-8"><EmployerForm /></div>
          <div className="lg:col-span-4">
            <Aside title="Was danach passiert" items={[
              "Wir prüfen Ihre Anfrage und melden uns per E-Mail.",
              "Im Gespräch klären wir Anforderungen und Rahmenbedingungen.",
              "Sie erhalten ein schriftliches Angebot mit Leistungen, Provision und Zahlungsbedingungen.",
              "Die Anfrage ist für Sie unverbindlich.",
            ]} />
          </div>
        </div>
      </section>
    </>
  );
}

export function RegisterPage() {
  useSeo("Als Bewerber registrieren", "Kostenlos registrieren und in Deutschland arbeiten: PACTORA stellt Ihr Profil passenden Arbeitgebern vor.", "/bewerber-registrierung");
  return (
    <>
      <PageHero testid="register-hero" eyebrow="Bewerberregistrierung" lines={["Als Bewerber", "registrieren."]}
        intro="Füllen Sie das Formular aus – das dauert etwa fünf Minuten. Antworten können Sie auch auf Englisch schreiben. Die Registrierung ist kostenlos.">
        <Link to="/en/register" hrefLang="en" lang="en" className="inline-flex items-center gap-2 text-sm font-semibold text-[color:var(--teal-ink)] underline-offset-4 hover:underline" data-testid="register-switch-english"><Languages size={16} /> English version of this form</Link>
      </PageHero>
      <section className="bg-white pb-24 md:pb-32">
        <div className="container-x grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-8"><ApplicantForm /></div>
          <div className="lg:col-span-4">
            <Aside title="Gut zu wissen" items={[
              "Ihre Unterlagen werden privat gespeichert und sind nur für unser berechtigtes Team einsehbar.",
              "Für die Registrierung brauchen wir keine Passkopie und keine Gesundheitsdaten.",
              "Über eine Einstellung entscheidet der jeweilige Arbeitgeber.",
              "Visum, Beschäftigungserlaubnis und ggf. Anerkennung werden vor Arbeitsbeginn geklärt.",
            ]} />
          </div>
        </div>
      </section>
    </>
  );
}
